export type CodeEditorLanguage = "rego" | "yaml" | "json" | "html" | "plaintext" | "shell" | "hcl";

const EXTENSION_TO_LANGUAGE: Record<string, CodeEditorLanguage> = {
  ".tf": "hcl",
  ".tofu": "hcl",
  ".hcl": "hcl",
  ".tfvars": "hcl",
  ".yaml": "yaml",
  ".yml": "yaml",
  ".json": "json",
  ".html": "html",
  ".htm": "html",
  ".sh": "shell",
  ".bash": "shell",
  ".rego": "rego",
};

export const getLanguageByFileName = (fileName: string): CodeEditorLanguage => {
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex === -1) return "plaintext";

  const ext = fileName.slice(dotIndex).toLowerCase();

  return EXTENSION_TO_LANGUAGE[ext] ?? "plaintext";
};
